import { AppConfigComponents } from '../components';
import OverridableAppNavigationBar from './navigation/appNavigationBar';

export const components: AppConfigComponents = {
    appNavigationBar: OverridableAppNavigationBar,
};
